import Home from "./pages/Home.vue"
import Login from "./pages/Login.vue"
import Signup from "./pages/Signup.vue"
import Documents from "./pages/Documents.vue"
import Opportunities from "./pages/Opportunities.vue"
import ProgramSelect from "./pages/ProgramSelect.vue"
import SSO from "./pages/Sso.vue"
import {Auth} from "@aws-amplify/auth";
import { createRouter, createWebHashHistory } from 'vue-router';
import gtmService from "@/services/GoogleTagService";
import QuizL2 from "@/enrol/QuizL2";
import Education from "../enrol/Education";
import CourseOptions from "../enrol/CourseOptions";
import Language from "@/enrol/Language";



let isAuthenticated = () => new Promise((resolve) => {
  try {
    // let user = await Auth.currentAuthenticatedUser();
    Auth.currentAuthenticatedUser()
      .then((user) => {
        resolve(user);
      })
      .then(() => {
        resolve(null);
      })
      .catch((err) => {
        console.log(err);
        resolve(null);
      });
    // return user.signInUserSession != null;
  } catch (e) {
    console.log(e);

    resolve(null);
  }
})

let routeGuardAuth = async (to, from, next) => {
  // console.log(from, to, next);
  gtmService.saveAcivity(to.path, 'account' + to.path )

  if (to.name !== 'Login' || to.name !== 'Signup') {
    let res = await isAuthenticated(); //.then(res => {
      if (res) {
        next();
      } else {
        next({name: 'Login'});
      }
    // })

  } else {
    next()
  }
}

let routeGuard = async (to, from, next) => {
  gtmService.saveAcivity(to.path, 'account' + to.path )

  next();
}


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: routeGuardAuth
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: routeGuard
  },
  {
    path: '/sso',
    name: 'SSO',
    component: SSO,
    beforeEnter: routeGuard
  },
  {
    path: '/quizl2',
    name: 'QuizL2',
    component: QuizL2,
    beforeEnter: routeGuard
  },
  {
    path: '/education',
    name: 'Education',
    component: Education,
    beforeEnter: routeGuard
  },
  {
    path: '/language',
    name: 'Language',
    component: Language,
    beforeEnter: routeGuard
  },
  {
    path: '/course-options',
    name: 'CourseOptions',
    component: CourseOptions,
    beforeEnter: routeGuard
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    beforeEnter: routeGuard
  },
  {
    path: '/opportunities',
    name: 'Opportunities',
    component: Opportunities,
    beforeEnter: routeGuardAuth
  },
  {
    path: '/program-select',
    name: 'Program Select',
    component: ProgramSelect,
    beforeEnter: routeGuardAuth
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents,
    beforeEnter: routeGuardAuth
  },
  {
    path: "/:catchAll(.*)",
    redirect: '/'
  }
]

const actRouter = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHashHistory(),
  routes,
})

//
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   if (to.name !== 'Login' && !isAuthenticated) next({ name: 'Login' })
//   else next()
// })

export default actRouter


